<template>
  <div v-if="isV2EditOrder" class="itemRemove itemRemoveV2">
    <span @click="$emit('remove')" class="itemRemoveText">
      <img
        alt="Remove"
        class="itemRemoveImg"
        src="@/assets/img/icon_trash_v2.png"
      />
    </span>
  </div>
  <div v-else class="itemRemove">
    <span @click="$emit('remove')" class="itemRemoveText">
      {{ $t("order.btn.remove") }}
      <img
        alt="Remove"
        class="itemRemoveImg"
        src="@/assets/img/icon_trash.png"
      />
    </span>
  </div>
</template>
<script>
import { isV2EditOrder } from "@/utils/templateSettings";

export default {
  name: "RemoveButton",
  computed: {
    isV2EditOrder
  },
  props: {
    text: {
      type: String,
      default: "Remove"
    }
  }
};
</script>
<style>
.itemRemove {
  background: var(
    --component_order_listitems_common_removeButton_itemRemove_background
  );
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: var(--component_order_listitems_common_removeButton_itemRemove_color);
  font-family: var(
    --component_order_listitems_common_removeButton_itemRemove_font-family
  );
  font-size: var(
    --component_order_listitems_common_removeButton_itemRemove_font-size
  );
  margin: 10px 0 0 0;
  pointer-events: all;
  .itemRemoveImg {
    margin-left: 10px;
    width: 18px;
    height: 23px;
  }
}

.itemRemoveV2 {
  background: var(
    --component_order_listitems_common_removeButton_itemRemoveV2_background
  );
  display: flex;
  height: 35px;
  justify-content: center;
  margin: 0;
  width: 35px;
  .itemRemoveImg {
    height: 23px;
    margin: 0;
    width: 18px;
  }
}

.itemRemoveText {
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: var(
    --component_order_listitems_common_removeButton_itemRemoveText_text-transform
  );
}
</style>
